
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 35 35\" id=\"icon-social_instagram\" > <title>social_instagram</title> <g> <path d=\"M17.5,0A17.5,17.5,0,1,0,35,17.5,17.5,17.5,0,0,0,17.5,0Zm0,32.27A14.77,14.77,0,1,1,32.27,17.5,14.77,14.77,0,0,1,17.5,32.27Z\"/> <path d=\"M24,8.84H11.18A2.12,2.12,0,0,0,9.05,11v13A2.12,2.12,0,0,0,11.18,26H24a2.12,2.12,0,0,0,2.12-2.12V11A2.12,2.12,0,0,0,24,8.84Zm.11,15.08A.11.11,0,0,1,24,24H11.18a.11.11,0,0,1-.11-.11V11a.11.11,0,0,1,.11-.11H24a.11.11,0,0,1,.11.11Z\"/> <rect x=\"20.51\" y=\"12.35\" width=\"2.3\" height=\"2.11\"/> <circle cx=\"17.58\" cy=\"18.29\" r=\"2.27\"/> <path d=\"M21.2,18.28a3.62,3.62,0,0,1-7.24,0V16.67H12.34v6H22.81v-6H21.21Z\"/> </g> </symbol>";
module.exports = sprite.add(image, "icon-social_instagram");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/social_instagram.svg
 ** module id = 222
 ** module chunks = 24
 **/